import messagesEn from 'rde-view-common/locales/messages_en';
import messagesJa from 'rde-view-common/locales/messages_ja';
import { getLanguage, isNull, isNotEmpty } from 'rde-view-common/scripts/functions';

/**
 * メッセージ出力を行うUtilクラス
 */
export default class MessageUtils {

  /**
   * メッセージIDを元に言語対応されたメッセージを取得します。
   *
   * @param messageId メッセージID
   * @returns {*} メッセージ
   */
  static getMessage(messageId) {
    if (getLanguage() === 'ja') {
      return messagesJa[messageId];
    } else {
      return messagesEn[messageId];
    }
  }

  /**
   * メッセージをメッセージ表示領域に出力します。
   *
   * @param messages メッセージ配列
   */
  static setMessage(...messages) {
    if (isNull(messages)) return;
    messages = messages.flat().filter(message => isNotEmpty(message));
    if (isNotEmpty(messages)) this.$store.commit('messages', messages);
  }

  /**
   * メッセージ表示領域のメッセージをクリアします。
   */
  static clearMessage() {
    this.$store.commit('messages', []);
  }
}
